import HttpRequest from "../../utilities/httpRequest";
import {
  addAppointment,
  editAppointment,
  getDoctorAppointment,
  removeAppointment,
  getAppointment,
} from "./AppointmentActions";
import {
  hideLoader,
  showLoader,
  showSnackbar,
} from "../../utilities/UtilitiesActions";

export const addAppointmentRequest = (data) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = "appointments";

    return new HttpRequest(dispatch, url, "post", data).send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(showSnackbar("Appointment created successfully", "success"));

        dispatch(addAppointment(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        dispatch(showSnackbar(`${error.response.data.error}`, "error"));
        return Promise.reject(error);
      }
    );
  };
};

export const getAppointmentDetailsRequest = (id) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `appointments/${id}`;
    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(getAppointment(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        dispatch(showSnackbar(`${error.response.data.error}`, "error"));
        return Promise.reject(error);
      }
    );
  };
};

export const editAppointmentRequest = (id, data) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `appointments/${id}`;
    return new HttpRequest(dispatch, url, "put", data).send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(showSnackbar("Appointment updated successfully", "success"));
        dispatch(editAppointment(res.data.data));
        return Promise.resolve(res.data.data);
      },

      (error) => {
        dispatch(hideLoader());
        dispatch(showSnackbar(`${error.response.data.error}`, "error"));
        return Promise.reject(error);
      }
    );
  };
};
/**
 * Cancels an appointment with a mandatory reason. The backend soft-cancels
 * (status -> CANCELLED), keeps the row so it can stay on the calendar, and
 * sends the patient the WhatsApp cancellation message including the reason.
 *
 * NOTE: if the backend extends `DELETE appointments/:id` instead of adding a
 * dedicated route, only the `url`/method below need to change.
 *
 * @param id: appointment id
 * @param data: {cancellationReasonCode, cancellationReason, cancellationNote, cancelledBy}
 */
export const cancelAppointmentRequest = (id, data) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `appointments/${id}/cancel`;
    return new HttpRequest(dispatch, url, "patch", data).send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(showSnackbar("Appointment cancelled successfully", "success"));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar(
            `${error?.response?.data?.error || "Failed to cancel appointment"}`,
            "error"
          )
        );
        return Promise.reject(error);
      }
    );
  };
};

export const removeAppointmentRequest = (id) => {
  return (dispatch) => {
    dispatch(showLoader());
    const url = `appointments/${id}`;
    return new HttpRequest(dispatch, url, "delete").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(showSnackbar("Appointment deleted successfully", "success"));
        dispatch(removeAppointment(res.data.data));
        return Promise.resolve(res.data.data);
      },

      (error) => {
        dispatch(hideLoader());
        dispatch(showSnackbar(`${error.response.data.error}`, "error"));
        return Promise.reject(error);
      }
    );
  };
};
export const getDoctorAppointmentRequest = (params, isHideLoader) => {
  return (dispatch) => {
    if (!isHideLoader) {
      dispatch(showLoader());
    }
    // includeCancelled keeps CANCELLED rows in the response so the calendar can
    // show them struck through. Requires backend support; without it the
    // endpoint filters them out and cancelled slots disappear as before.
    const url = `appointments?userId=${params.userId}&includeCancelled=true`;
    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(getDoctorAppointment(res.data));
        return Promise.resolve(res.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

export const getDoctorAppointmentWithoutOrgIdRequest = (isHideLoader) => {
  return (dispatch) => {
    if (!isHideLoader) {
      dispatch(showLoader());
    }
    // Feeds the doctor's calendar (which renders cancelled slots struck through)
    // and DoctorHome's today list (which filters them out via inLifecycle), so
    // including them here is safe for both. Requires backend support.
    const url = `doctor/appointments?includeCancelled=true`;
    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(getDoctorAppointment(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};

export const getAppointmentInsightRequest = (orgId, isHideLoader) => {
  return (dispatch) => {
    if (!isHideLoader) {
      dispatch(showLoader());
    }
    const url = `appointments/summmary/all?orgId=${orgId}`;
    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());
        dispatch(getDoctorAppointment(res.data.data));
        return Promise.resolve(res.data.data);
      },
      (error) => {
        dispatch(hideLoader());
        return Promise.reject(error);
      }
    );
  };
};
